import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniabusonrentinsangli() {



    const cardData =
    {
        keyword: 'Urbania Bus On Rent in Sangli',
        heading: 'Urbania on rent in pune: Urbania Bus On Rent in Sangli',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Urbania Bus On Rent in Sangli for corporate groups, families, tourists, and event travelers planning group travel to and from Sangli. Our well-maintained Force Urbania bus fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for long-distance journeys, corporate outings, airport transfers, weddings, sightseeing tours, and outstation trips between Pune and Sangli. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the trusted choice for Urbania bus hire in Sangli.',

        top: 'Top Places to Visit in Sangli with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Ganapati Temple, Sangli",
    "description": "The Ganapati Temple is the most prominent religious landmark in Sangli and a major center of faith for devotees across Maharashtra. The temple is dedicated to Lord Ganesha and is known for its beautifully carved idol, spacious courtyard, and peaceful spiritual atmosphere. Daily rituals, festivals like Ganesh Chaturthi, and special aartis attract large gatherings. The temple complex also plays an important cultural role in Sangli’s social life."
  },
  {
    "title": "Krishna River Ghat",
    "description": "The Krishna River Ghat is a scenic and spiritual spot where locals gather for morning walks, evening relaxation, and religious rituals. The calm flow of the Krishna River, combined with wide ghats and open spaces, creates a peaceful environment. During festivals and special occasions, the ghat becomes vibrant with lamps, prayers, and cultural activities, making it one of Sangli’s most serene attractions."
  },
  {
    "title": "Sangli Fort (Ganesh Durg)",
    "description": "Sangli Fort, also known as Ganesh Durg, is a historic fortification built by the Patwardhan rulers. Though parts of the fort are now in ruins, it still reflects Maratha architectural style and historical importance. The fort houses the Ganapati Temple and offers insight into Sangli’s royal past. History enthusiasts and photographers enjoy exploring this heritage site."
  },
  {
    "title": "Irwin Bridge",
    "description": "Irwin Bridge is an iconic landmark connecting Sangli and Miraj across the Krishna River. Known for its colonial-era architecture, the bridge offers beautiful river views, especially during sunrise and sunset. It is a favorite spot for photography and leisurely walks, symbolizing Sangli’s historical and infrastructural development."
  },
  {
    "title": "Willingdon College Campus",
    "description": "Willingdon College is one of the oldest educational institutions in the region, known for its vast campus and colonial-style buildings. The well-maintained gardens, tree-lined paths, and heritage structures make it a peaceful place to visit. The campus reflects Sangli’s contribution to education and cultural growth over the decades."
  },
  {
    "title": "Sangli Zoo (Rajaram Bapu Zoological Park)",
    "description": "Sangli Zoo is a family-friendly attraction featuring a variety of animals, birds, and reptiles in a well-organized environment. The zoo focuses on wildlife awareness, conservation, and education. Children and families enjoy spending time here, making it a popular recreational spot within the city."
  },
  {
    "title": "Chandoli National Park (Near Sangli)",
    "description": "Located near Sangli, Chandoli National Park is part of the Sahyadri Tiger Reserve and is rich in biodiversity. The park features dense forests, waterfalls, wildlife, and scenic trekking routes. Nature lovers, wildlife enthusiasts, and adventure seekers visit for jungle safaris, birdwatching, and eco-tourism experiences."
  },
  {
    "title": "Sagareshwar Wildlife Sanctuary",
    "description": "Sagareshwar Wildlife Sanctuary is a man-made forest reserve known for its peaceful environment and diverse wildlife. Visitors can spot deer, peacocks, blackbucks, and various bird species. The sanctuary also includes temples and walking trails, making it a perfect blend of nature, spirituality, and relaxation."
  },
  {
    "title": "Miraj Musical Heritage",
    "description": "Miraj, located adjacent to Sangli, is globally famous for manufacturing traditional Indian musical instruments like sitars, tanpuras, and veenas. Music lovers visit Miraj to explore instrument workshops and learn about the city’s contribution to Indian classical music. It highlights Sangli’s rich cultural and artistic heritage."
  },
  {
    "title": "Sangli Market Area",
    "description": "Sangli’s market area is known for its bustling streets, local shopping, and traditional goods. Visitors can explore textiles, spices, daily essentials, and regional snacks. The vibrant atmosphere provides an authentic local experience and reflects the commercial life of Sangli."
  }
],






"services": [
    {
      "name": "Urbania Bus on Rent in Sangli",
      "description": "Urbania Bus on Rent in Sangli offers reliable and well-maintained Urbania buses for local and outstation travel. Ideal for families, corporate groups, and tourists, these buses provide comfort, spacious seating, and professional chauffeur service for a hassle-free journey across Sangli."
    },
    {
      "name": "Sangli Urbania Bus Hire",
      "description": "Sangli Urbania Bus Hire provides convenient rental services with AC and non-AC buses for city travel, sightseeing, and group tours. Perfect for families, corporate trips, and friends, ensuring a comfortable and safe journey."
    },
    {
      "name": "Urbania Rental Service Sangli",
      "description": "Urbania Rental Service Sangli offers flexible rental options for Urbania buses with professional drivers, suitable for corporate events, family outings, weddings, and outstation trips."
    },
    {
      "name": "Urbania AC Bus on Rent Sangli",
      "description": "Urbania AC Bus on Rent Sangli provides fully air-conditioned Urbania buses for comfortable city travel, corporate trips, and long-distance journeys. Ensures a smooth ride with climate-controlled interiors and experienced chauffeurs."
    },
    {
      "name": "Corporate Urbania Hire Sangli",
      "description": "Corporate Urbania Hire Sangli delivers professional transport solutions for business travel, office events, and employee commute. Features include AC buses, punctual service, and trained drivers for a seamless corporate experience."
    },
    {
      "name": "Urbania for Outstation Sangli",
      "description": "Urbania for Outstation Sangli offers AC and non-AC buses for long-distance travel, including weekend getaways, sightseeing tours, and intercity trips. Provides luggage support, comfortable seating, and courteous drivers familiar with the routes."
    },
    {
      "name": "Urbania Airport Transfer Sangli",
      "description": "Urbania Airport Transfer Sangli provides timely pick-up and drop services to and from nearby airports. Ideal for corporate travelers, tourists, and families seeking stress-free, comfortable, and punctual airport transport."
    },
    {
      "name": "Luxury Urbania Sangli",
      "description": "Luxury Urbania Sangli offers high-end air-conditioned buses with plush seating, modern interiors, and professional drivers. Perfect for VIP travel, weddings, corporate outings, and luxury family tours."
    },
    {
      "name": "Affordable Urbania Hire Sangli",
      "description": "Affordable Urbania Hire Sangli provides budget-friendly bus rental options for city travel, local sightseeing, and group outings without compromising on comfort, safety, or convenience."
    },
    {
      "name": "Chauffeur Driven Urbania Sangli",
      "description": "Chauffeur Driven Urbania Sangli ensures a stress-free travel experience with verified and experienced drivers. Ideal for families, corporate groups, and tourists who want a safe and comfortable ride across Sangli."
    },
    {
      "name": "Urbania for Wedding Events Sangli",
      "description": "Urbania for Wedding Events Sangli offers spacious and air-conditioned buses for wedding guests and party travel. Ensures punctual service, comfort, and elegance for special celebrations."
    },
    {
      "name": "Urbania for Office Trips Sangli",
      "description": "Urbania for Office Trips Sangli provides organized and professional transport for team outings, office picnics, and business travel. Features comfortable seating, AC buses, and trained chauffeurs for smooth office travel."
    },
    {
      "name": "Best Urbania Rental Sangli",
      "description": "Best Urbania Rental Sangli offers top-rated Urbania buses with excellent customer service, timely pickups, and comfortable travel for both local and outstation trips. Suitable for families, corporate groups, and tourists."
    },
    {
      "name": "Urbania Group Travel Sangli",
      "description": "Urbania Group Travel Sangli provides large-capacity buses for group outings, excursions, and tours. Ensures safe, comfortable, and convenient travel for friends, families, and corporate groups."
    },
    {
      "name": "Reliable Urbania Hire Sangli",
      "description": "Reliable Urbania Hire Sangli offers dependable and punctual Urbania bus services for city and outstation travel. Known for safety, comfort, and professional drivers, making group travel seamless and enjoyable."
    }
  ],
  "tableData": [
    ["Urbania Bus on Rent in Sangli", "Sangli Urbania Bus Hire"],
    ["Urbania Rental Service Sangli", "Urbania AC Bus on Rent Sangli"],
    ["Corporate Urbania Hire Sangli", "Urbania for Outstation Sangli"],
    ["Urbania Airport Transfer Sangli", "Luxury Urbania Sangli"],
    ["Affordable Urbania Hire Sangli", "Chauffeur Driven Urbania Sangli"],
    ["Urbania for Wedding Events Sangli", "Urbania for Office Trips Sangli"],
    ["Best Urbania Rental Sangli", "Urbania Group Travel Sangli"],
    ["Reliable Urbania Hire Sangli", ""]
  ],



  "whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania Bus On Rent in Sangli",
        "WhyChoosedescription": "Urbania Bus On Rent in Sangli is perfect for group travel, family outings, corporate trips, weddings, school tours, and outstation journeys, providing comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Spacious and Well-Equipped Force Urbania Bus",
        "WhyChoosedescription": "Urbania Bus On Rent in Sangli offers modern Force Urbania buses with air-conditioning, ample legroom, and comfortable pushback seating for long and short trips."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania Bus On Rent in Sangli comes with skilled drivers familiar with Sangli, Kolhapur, Pune, and nearby routes, ensuring safe, timely, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Urbania Bus On Rent in Sangli for competitive rates with no hidden charges, making group and corporate travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania Bus On Rent in Sangli provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania Bus On Rent in Sangli is available for hourly rentals, full-day bookings, multi-day trips, corporate travel, weddings, sightseeing tours, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Buses",
        "WhyChoosedescription": "All buses for Urbania Bus On Rent in Sangli are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania Bus On Rent in Sangli guarantees on-time pickups and dependable service, ensuring smooth and stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania Bus On Rent in Sangli available for local and outstation travel?',
        answer: 'Yes, Urbania Bus On Rent in Sangli can be booked for city travel, corporate trips, family outings, and long-distance journeys.',
    },
    {
        question: 'How can I book Urbania Bus On Rent in Sangli?',
        answer: 'You can book Urbania Bus On Rent in Sangli via phone, WhatsApp, or online for easy and quick reservations.',
    },
    {
        question: 'Why choose Urbania Bus On Rent in Sangli?',
        answer: 'Urbania Bus On Rent in Sangli offers spacious seating, professional drivers, clean buses, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Urbania Bus On Rent in Sangli are licensed, trained, and experienced in handling Force Urbania buses safely.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Urbania Bus On Rent in Sangli allows flexible pickup and drop locations across Sangli and nearby areas.',
    },
    {
        question: 'Is Urbania Bus On Rent in Sangli available 24x7?',
        answer: 'Yes, Urbania Bus On Rent in Sangli operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are regularly sanitized, cleaned, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania Bus On Rent in Sangli accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Urbania Bus be used for corporate, family, and outstation trips?',
        answer: 'Yes, Urbania Bus On Rent in Sangli is ideal for group trips, corporate travel, family outings, and long-distance journeys.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sandeep Patil',
        feedback: 'Urbania Bus On Rent in Sangli provided a smooth and comfortable ride for our family function. Spacious and reliable service.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Neha Kulkarni',
        feedback: 'We hired Urbania Bus On Rent in Sangli for a corporate outing. Clean, punctual, and excellent service.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Amit Jadhav',
        feedback: 'Urbania Bus On Rent in Sangli made our group travel hassle-free and enjoyable. Highly recommended.',
        rating: 5,
    },
];




























































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Bus On Rent in Sangli",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-sangli.jpg",
  "description": "Urbania Bus On Rent in Sangli offers AC and non-AC Urbania buses for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation in Sangli and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-bus-on-rent-sangli"
  }
};




    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania Bus On Rent in Sangli | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania Bus On Rent in Sangli for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Sangli."
  />

  <meta
    name="keywords"
    content="Urbania Bus on Rent in Sangli, Sangli Urbania Bus Hire, Urbania Rental Service Sangli, Urbania AC Bus on Rent Sangli, Corporate Urbania Hire Sangli, Urbania for Outstation Sangli, Urbania Airport Transfer Sangli, Luxury Urbania Sangli, Affordable Urbania Hire Sangli, Chauffeur Driven Urbania Sangli, Urbania for Wedding Events Sangli, Urbania for Office Trips Sangli, Best Urbania Rental Sangli, Urbania Group Travel Sangli, Reliable Urbania Hire Sangli"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/70.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniabusonrentinsangli;